var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserWithHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50651 6.49837C11.1173 6.49837 12.4232 5.19254 12.4232 3.58171C12.4232 1.97088 11.1173 0.665039 9.50651 0.665039C7.89568 0.665039 6.58984 1.97088 6.58984 3.58171C6.58984 5.19254 7.89568 6.49837 9.50651 6.49837Z",
    stroke: "#322C36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.16992 16.0817C1.16992 12.3996 4.52784 9.41504 8.66992 9.41504M12.7741 10.665C11.8883 10.665 11.1699 11.5021 11.1699 12.5342C11.1699 14.4038 13.0658 16.103 14.0866 16.4984C15.1074 16.103 17.0033 14.4038 17.0033 12.5342C17.0033 11.5025 16.2849 10.665 15.3991 10.665C14.8566 10.665 14.377 10.9788 14.0866 11.4592C13.7962 10.9788 13.3166 10.665 12.7741 10.665Z",
    stroke: "#322C36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWithHeart);
export default __webpack_public_path__ + "static/media/user-with-heart.718a7f9d3743c4da9f59c81d29813dc5.svg";
export { ForwardRef as ReactComponent };